// @flow
import React from 'react';
import styled from 'styled-components';
import { Button, Text } from 'bench-internal-theme';
import { Modal } from 'modal-components';

const ButtonLayout = styled.div`
  display: grid;
  grid-column-gap: 8px;
  grid-template-columns: 1fr 1fr;
  padding-top: 24px;
`;

type ConfirmationModalProps = {
  closeModal: () => void,
  description?: string,
  onConfirm: () => void,
  title: string,
};

const ConfirmationModal = ({
  closeModal,
  onConfirm,
  title,
  description,
}: ConfirmationModalProps) => (
  <Modal>
    <Modal.Header title={title} onClose={closeModal} />
    <Modal.Body>
      {description && <Text>{description}</Text>}
      <ButtonLayout>
        <Button onClick={closeModal} styleType="ghost">
          Cancel
        </Button>
        <Button
          onClick={() => {
            closeModal();
            return onConfirm();
          }}
          aria-label="Confirm"
          styleType="primary"
          type="submit"
        >
          Confirm
        </Button>
      </ButtonLayout>
    </Modal.Body>
  </Modal>
);

ConfirmationModal.defaultProps = {
  description: undefined,
};

export default ConfirmationModal;
